import { Flex, Grid, Text } from '@raskrask-dk/rr-components'
import { useTranslation } from 'react-i18next'
import { ReactElement } from 'react'
import { StyledDiscount, StyledPaymentOverview } from './styles'
import { PropsPaymentOverviewTemplate, PropsPriceTemplate } from './props'

const PriceTemplate = ({
    children,
    price,
    text,
}: PropsPriceTemplate): ReactElement => (
    <Grid>
        <Flex>
            <Text primary bold>
                {text}
            </Text>
            <Text primary bold>
                {price}
            </Text>
        </Flex>
        {children}
    </Grid>
)

const PaymentOverviewTemplate = ({
    discountList,
    finalPrice,
    initialPrice,
    shouldShowPriceDetails,
    shouldShowVatPrice,
    vatPrice,
    basisType,
    isPackage,
}: PropsPaymentOverviewTemplate): ReactElement => {
    const { t } = useTranslation()

    const preText = 'checkout.paymentoverview'

    const vatPriceTemplate = shouldShowVatPrice && (
        <Flex>
            <Text primary size={'s'}>
                {t(`common:priceMomsOfTotal`)}
            </Text>
            <Text primary size={'s'}>
                {vatPrice},-
            </Text>
        </Flex>
    )

    const initialPriceTemplate = (
        <PriceTemplate
            price={`${initialPrice},-`}
            text={
                isPackage ? t(`${preText}.packageprice`) : t(`${preText}.price`)
            }
        >
            {vatPriceTemplate}
        </PriceTemplate>
    )

    const extraDiscountsTemplate = discountList.map((discount, key) => (
        <PriceTemplate
            key={key}
            price={<StyledDiscount>-{discount.price},-</StyledDiscount>}
            text={discount.text}
        />
    ))

    const finalPriceTemplate = (
        <PriceTemplate
            price={`${finalPrice},-`}
            text={t(`${preText}.finalpricetext`)}
        >
            {vatPriceTemplate}
        </PriceTemplate>
    )

    const paymentOverViewInfoText = isPackage
        ? t(`${preText}.klippekortinfo`)
        : basisType.id === 1
        ? t(`${preText}.massageinfo`)
        : t(`${preText}.generalinfo`)

    return (
        <StyledPaymentOverview>
            {shouldShowPriceDetails && (
                <Grid>
                    {initialPriceTemplate}
                    {extraDiscountsTemplate}
                </Grid>
            )}
            <Grid gap={8}>
                {finalPriceTemplate}
                <Text primary size="xs">
                    {paymentOverViewInfoText}
                </Text>
            </Grid>
        </StyledPaymentOverview>
    )
}

export default PaymentOverviewTemplate
